export default __webpack_public_path__ + "static/media/pc_step_1_Cn.5ba91618.jpg";